// extracted by mini-css-extract-plugin
module.exports = {"graph_size":"PersonalAnalyticsSertch_graph_size_3MFw1"};